import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'px-verify-email-landing-page',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class VerifyEmailLandingPageComponent {
  // see registration.effects: handleEmailLanding
}
